import { EditorContext, type Editor } from '@tiptap/react';
import { type ReactNode, useId, useState } from 'react';

import { BaseEditorProvider } from '@/components/ui/editor/base-editor-context';
import { EditorBubble } from '@/components/ui/editor/components/editor-bubble';
import { EditorSearchBar } from '@/components/ui/editor/components/editor-search-bar';
import { LinkSelector } from '@/components/ui/editor/selectors/link';
import { NodeSelector } from '@/components/ui/editor/selectors/node';
import { TextButtons } from '@/components/ui/editor/selectors/text-buttons';

type ComposerEditorControlsProps = {
  editor: Editor | null;
  children: ReactNode;
  find?: boolean;
  findPortalContainer?: HTMLElement | null;
};

export function ComposerEditorControls({
  editor,
  children,
  find,
  findPortalContainer,
}: ComposerEditorControlsProps) {
  const editorId = useId();
  const [openLinkSelector, setOpenLinkSelector] = useState(false);
  const [openNodeSelector, setOpenNodeSelector] = useState(false);

  if (!editor) return null;

  return (
    <BaseEditorProvider
      editorId={`composer-${editorId}`}
      findScrollableParent={!!find}
    >
      <EditorContext.Provider value={{ editor }}>
        {children}
        <EditorBubble>
          <LinkSelector
            open={openLinkSelector}
            onOpenChange={setOpenLinkSelector}
          />
          <TextButtons featureSet="composer" />
          <NodeSelector
            open={openNodeSelector}
            onOpenChange={setOpenNodeSelector}
            featureSet="composer"
          />
        </EditorBubble>
        {find && <EditorSearchBar portalContainer={findPortalContainer} />}
      </EditorContext.Provider>
    </BaseEditorProvider>
  );
}
